// src/components/admin/AdminSales.tsx
// Painel de Vendas - ATUALIZADO: Removido produtos, adicionado Ranking

import React, { useState } from 'react';
import { TrendingUp, Users, DollarSign, Settings, PieChart } from 'lucide-react';
import './AdminSales.css';

import OverviewTab from './sales/OverviewTab';
import VendorsTab from './sales/VendorsTab';
import SalesHistoryTab from './sales/SalesHistoryTab';
import ProfitabilityTab from './sales/ProfitabilityTab';
import SettingsTab from './sales/SettingsTab';
import RevenueByCategory from './sales/RevenueByCategory';

type SalesTab = 'overview' | 'vendors' | 'sales' | 'profitability' | 'products' | 'revenue' | 'settings';

interface AdminSalesProps {
    onShowToast: (message: string, type: 'success' | 'error' | 'info') => void;
}

const AdminSales: React.FC<AdminSalesProps> = ({ onShowToast }) => {
    const [activeTab, setActiveTab] = useState<SalesTab>('overview');

    const tabs = [
        { id: 'overview' as SalesTab, label: 'Visão Geral', icon: TrendingUp },
        { id: 'sales' as SalesTab, label: 'Vendas', icon: DollarSign },
        { id: 'vendors' as SalesTab, label: 'Vendedores', icon: Users },
        { id: 'profitability' as SalesTab, label: 'Rentabilidade', icon: PieChart },
        { id: 'revenue' as SalesTab, label: 'Receita por Categoria', icon: DollarSign },
        { id: 'settings' as SalesTab, label: '', icon: Settings },
    ];

    return (
        <div className="admin-sales-container adm-page">
            <div className="adm-page-header">
                <h2 className="adm-page-title">Vendas e Produtos</h2>
                <p className="adm-page-subtitle">
                    Gerencie vendas, comissões e produtos
                </p>
            </div>

            <div className="adm-tabs">
                {tabs.map((tab) => {
                    const Icon = tab.icon;
                    return (
                        <button
                            key={tab.id}
                            className={`adm-tab ${activeTab === tab.id ? 'active' : ''}`}
                            onClick={() => setActiveTab(tab.id)}
                        >
                            <Icon size={18} strokeWidth={1.5} />
                            {tab.label && <span>{tab.label}</span>}
                        </button>
                    );
                })}
            </div>

            <div className="sales-content">
                {activeTab === 'overview' && (
                    <OverviewTab onShowToast={onShowToast} />
                )}

                {activeTab === 'sales' && (
                    <SalesHistoryTab onShowToast={onShowToast} />
                )}

                {activeTab === 'vendors' && (
                    <VendorsTab onShowToast={onShowToast} />
                )}

                {activeTab === 'profitability' && (
                    <ProfitabilityTab onShowToast={onShowToast} />
                )}

                {activeTab === 'revenue' && (
                    <RevenueByCategory onShowToast={onShowToast} />
                )}

                {activeTab === 'settings' && (
                    <SettingsTab onShowToast={onShowToast} />
                )}
            </div>
        </div>
    );
};

export default AdminSales;